import { render, staticRenderFns } from "./CreateEmployee.vue?vue&type=template&id=54030877&"
import script from "./CreateEmployee.vue?vue&type=script&lang=js&"
export * from "./CreateEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports